import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { useIntl } from 'react-intl'
import { shallowEqual, useSelector } from 'react-redux'
import { RootState } from '../../../../setup'
import clsx from 'clsx'
import { apiGetStoredFiles } from '../../../redux/api'
import FilesTable from './components/FilesTable'
import './FileArea.scss'
import { KTSVG } from '../../../../_metronic/helpers'
import _ from 'lodash'

const FilesPage: React.FC = () => {
  const intl = useIntl()

  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [fileList, setFileList] = useState<any>([])
  const [fileInfo, setFileInfo] = useState<any>([])
  const [itemsPerPage, setItemsPerPage] = useState<number>(100)
  const [currentPage, setCurrentPage] = useState<number>(1)
  const [paginationInfo, setPaginationInfo] = useState<any>(null)
  const [listView, setListView] = useState<any>('compact')
  const [search, setSearch] = useState<any>('')
  const [counts, setCounts] = useState<any>({
    mp4: 0,
    mdt: 0,
    jpg: 0,
  })
  const accessToken: any = useSelector<RootState>(({ auth }) => auth.accessToken, shallowEqual)

  const getUserFiles = (page: number = 1, limit: number = itemsPerPage) => {
    setIsLoading(true)

    const query = {
      includeDeleted: true,
      limit: limit,
      page: page,
    }

    apiGetStoredFiles(query)
      .then(({ data }: any) => {
        if (data.status === 200) {
          const files = data.response.response || []
          const pagination = data.response.pagination || null
          setFileList(files)
          setFileInfo(files)
          setPaginationInfo(pagination)
          setIsLoading(false)
        } else {
          setFileList([])
          setFileInfo([])
          setPaginationInfo(null)
          toast.error(intl.formatMessage({ id: 'TOAST.ERROR_WHILE_REQUESTING_FILES' }))
          setIsLoading(false)
        }
      })
      .catch(() => {
        setIsLoading(false)
        setFileList([])
        setFileInfo([])
        setPaginationInfo(null)
        toast.error(intl.formatMessage({ id: 'TOAST.ERROR_WHILE_REQUESTING_FILES' }))
      })
  }

  useEffect(() => {
    if (accessToken) {
      getUserFiles(currentPage, itemsPerPage)
    }
  }, [accessToken, currentPage, itemsPerPage])

  const handleDelete = (id: any) => {
    const updatedList = fileList.filter((file: any) => file.id !== id)
    setFileList(updatedList)
    setFileInfo(updatedList)
  }

  const extractVehicleNo = (title: string = '') => {
    const match = title.match(/vehicle:\s*(.*)$/i);
    return match ? match[1].trim() : '';
  };

  useEffect(() => {
    if (!search) {
      setFileInfo(fileList);
      return;
    }

    let filteredfileList = _.filter(fileList, function (o) {
      const vehicleNo = extractVehicleNo(o.title).toLowerCase();

      if (vehicleNo.indexOf(search) > -1) {
        return o;
      } else if (o.deviceId?.toLowerCase().indexOf(search) > -1) {
        return o;
      }
    });

    setFileInfo(filteredfileList);
  }, [fileList, search]);

  const handleSearch = (q: any) => {
    setSearch(q.toLowerCase());
  };


  const extractExtension = (url: string) => {
    try {
      const pathname = new URL(url).pathname
      const lastSegment = pathname.substring(pathname.lastIndexOf('/') + 1)
      const dotIndex = lastSegment.lastIndexOf('.')
      return dotIndex !== -1 ? lastSegment.substring(dotIndex + 1) : ''
    } catch {
      return ''
    }
  }

  useEffect(() => {
    if (!fileList?.length) {
      setCounts({ mp4: 0, mdt: 0, jpg: 0 })
      return
    }

    const newCounts = {
      mp4: 0,
      mdt: 0,
      jpg: 0,
    }

    fileList.forEach((item: any) => {
      const ext = extractExtension(item.fileAccessLink).toLowerCase()

      if (ext === 'mp4') newCounts.mp4++
      else if (ext === 'mdt') newCounts.mdt++
      else if (ext === 'jpg' || ext === 'jpeg') newCounts.jpg++
    })

    setCounts(newCounts)
  }, [fileList])

  return (
    <React.Fragment>
      <div className={`card file-area`}>
        {/* begin::Header */}
        <div className='card-header border-0 pt-10' style={{ gap: '32px', marginBottom: '32px' }}>
          <h1 className='w-100 file-section border-bottom'>
            <span className='card-label fw-bolder text-primary'>
              {intl.formatMessage({ id: 'MENU.FILE_AREA' })}
            </span>
            <div className='files-info'>
              <span className='info-item'>
                <KTSVG
                  path='/media/icons/duotone/General/video_file.svg'
                  className='mdt-icon icon'
                  fill='currentColor'
                />
                <span className='label text-dark'>{counts.mdt} MDT</span>
              </span>
              <span className='info-item'>
                <KTSVG
                  path='/media/icons/duotone/General/live_tv.svg'
                  className='mp4-icon icon'
                  fill='currentColor'
                />
                <span className='label text-dark'>{counts.mp4} MP4</span>
              </span>
              <span className='info-item'>
                <KTSVG
                  path='/media/icons/duotone/General/image.svg'
                  className='jpg-icon icon'
                  fill='currentColor'
                />
                <span className='label text-dark'>{counts.jpg} JPG</span>
              </span>
            </div>
          </h1>
          <div className='d-flex align-items-center w-100'>
            <div className='d-flex grow w-100 align-items-center' style={{ gap: '40px' }}>
              <span className='device-input'>
                <label
                  className='form-label text-dark d-block'
                  style={{ fontSize: 12, lineHeight: '18px' }}
                >
                  {intl.formatMessage({ id: 'INPUT.LABEL.SEARCH_FOR_DEVICE' })} :
                </label>

                <div className='d-flex align-items-center position-relative'>
                  <KTSVG
                    path='/media/icons/duotune/general/gen021.svg'
                    className='svg-icon-1 position-absolute ms-6'
                  />
                  <input
                    type='text'
                    data-kt-user-table-filter='search'
                    className='form-control form-control-solid w-325px ps-14'
                    placeholder={intl.formatMessage({
                      id: 'INPUT.PLACEHOLDER.START_TYPING_TO_SHOW_RESULTS',
                    })}
                    value={search}
                    onChange={(e) => handleSearch(e.target.value)}
                  />
                </div>
              </span>
            </div>
          </div>
        </div>
        {!isLoading && (
          <FilesTable
            fileList={fileInfo}
            paginationInfo={paginationInfo}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            itemsPerPage={itemsPerPage}
            handleDelete={handleDelete}
            setItemsPerPage={setItemsPerPage}
            setListView={setListView}
            listView={listView}
          />
        )}
      </div>
    </React.Fragment>
  )
}
export default FilesPage
